export default "__VITE_ASSET__DKiaRwC6__"